const jsCookie = require('js-cookie');

export default (USER_LANGUAGE = 'USER_LANGUAGE') => {
  if (!jsCookie.get(USER_LANGUAGE)) {
    jsCookie.set(USER_LANGUAGE, 'ka');
  }
  return jsCookie.get(USER_LANGUAGE);
};
